<template>
    <div ref="container" />
</template>

<script lang="ts">
import Vue from "vue";

import Bus from "@/utils/events/bus";

interface ReactHandle {
    unmount(): void;
    render(): void;
}

export default Vue.extend({
    name: "ReactMountPcpHistorico",

    data(): { handle: ReactHandle | null; alive: boolean } {
        return { handle: null, alive: false };
    },

    async mounted() {
        this.alive = true;
        Bus.$emit("hide-nav-menu", true);
        // @ts-ignore
        const { mountPcpHistoricoApp } = await import(/* webpackChunkName: "pcp-historico-react" */ "@/react/mount");
        if (!this.alive) {
            return;
        }
        const container = this.$refs.container as HTMLElement | null;
        if (!container) {
            return;
        }
        this.handle = (mountPcpHistoricoApp as (el: HTMLElement) => ReactHandle)(container);
        this.handle.render();
    },

    beforeDestroy() {
        this.alive = false;
        this.handle?.unmount();
        this.handle = null;
    },
});
</script>
